export default {
    'PincodeList': (state, payload) => {
        state.pincodesList = payload
    },
    localMallProductsOfShop: (state, payload) => {
        state.localMallProducts = payload
    }
}